export default "__VITE_ASSET__BQ3wMrm8__"